import React, { Component } from 'react';
import CollapsablePanel from './CollapsePanel';
import ShippyProConfiguration from './ShippyProConfiguration';

class ShippyProConfigurations extends Component {
    render() {
        let { fields, dispatch } = this.props;

        return <div>
            {fields.map((el, idx, all) => {
                let configuration = all.getAll()[idx];
                return <div key={idx}>
                    <CollapsablePanel configuration={'configuration' + idx} section={'configuration' + idx} title={`ShippyPro Instance #${idx + 1}`}>
                        <ShippyProConfiguration dispatch={dispatch} configuration={configuration} el={el} idx={idx} onClick={() => fields.remove(idx)} />
                    </CollapsablePanel>
                </div>
            })}
            <br />

            <button className="btn btn-sm btn-primary"  title="Configure a new ShippyPro instance" onClick={() => fields.push({
                apiKey: ``,
                locationId: -1,
            })}><i className="widget-add-item fa fa-plus-circle" ></i>{""} Add</button>
        </div>
    }
}

export default ShippyProConfigurations;



// WEBPACK FOOTER //
// app/containers/ShippyProConfigurations.jsx